import {
  Button,
  Divider,
  IconButton,
  Menu,
  MenuItem,
  Typography,
} from '@material-ui/core';
import { MoreHoriz } from '@material-ui/icons';
import { deleteMedia, putMedia } from '@webapps/business';
import {
  Modal,
  useAuth,
  useMutation,
  useToast,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import PushPin from 'components/Icons/pushPin';
import ModalLarge from 'components/ModalLarge';
import parse from 'html-react-parser';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import * as React from 'react';


const MediaCard = ({
  description,
  id,
  label,
  path,
  priority,
  type,
  title,
  refetch,
}) => {
  const {
    classes,
    css,
    cx,
    global,
    theme: { spacing },
  } = useStyles(styles);

  const { addToast } = useToast();

  const { isSuccess: isSuccessDelete, mutateAsync: mutateDeleteMedia } =
    useMutation(deleteMedia);

  useEffect(() => {
    if (isSuccessDelete) {
      addToast({
        status: 'success',
        message: 'Opération réussie',
      });
      refetch();
    }
  }, [isSuccessDelete]);


  const deleteMediaSpecific = async (id) => {
    await mutateDeleteMedia({
      id,
    });
  };

  const [anchorDeleteMedia, setAnchorDeleteMedia] = useState(null);
  const openDeleteMedia = Boolean(anchorDeleteMedia);

  return (
    <>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          height: '100%',
          marginBottom: '16px',
        }}
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <div>
            <Typography className={cx(global.title, classes.mediaTitle)}>{label}</Typography>
          </div>
          <div>
            <IconButton
              onClick={(e) => setAnchorDeleteMedia(e.currentTarget)}
              size="24px"
              aria-controls={'menu'}
              style={{
                margin: '0px 3px',
                alignSelf: 'baseline',
                borderRadius: '20px',
                border: '1px solid #C0D9FF',
                backgroundColor: '#F3F7FF',
                width: '26px',
                display: 'flex',
                justifyContent: 'center',
                height: '26px',
                alignItems: 'center',
                cursor: 'pointer',
              }}
            >
              <MoreHoriz style={{ color: '#5A6DA1', fontSize: '15.00px' }} />
            </IconButton>
            <Menu
              anchorEl={anchorDeleteMedia}
              id="menu"
              open={openDeleteMedia}
              onClose={() => setAnchorDeleteMedia(false)}
              onClick={() => setAnchorDeleteMedia(false)}
              PaperProps={{ elevation: 2 }}
              transformOrigin={{ horizontal: 'left', vertical: -50 }}
              anchorOrigin={{ horizontal: 'left', vertical: 'top' }}
            >
              <MenuItem
                onClick={() => deleteMediaSpecific(id)}>
                Supprimer
              </MenuItem>
            </Menu>
          </div>
        </div>
        <div className={cx(global.infoText, classes.mediaParagraph)}>{parse(description)}</div>
        <div
          style={{
            display: 'flex',
            justifyContent: priority < 3 ? 'space-between' : 'flex-end',
          }}
        >
          {priority === 1 ? (
            <div className={classes.pinned}>
              <PushPin color="#008000" />
              Epinglé
            </div>
          ) : (
            <></>
          )}
          {priority === 2 ? (
            <div className={classes.pinned}>
              <PushPin color="#008000" />
              Epinglé
            </div>
          ) : (
            <></>
          )}
        </div>
        <div
          className={cx(
            classes.block,
            css({
              backgroundImage:
                type === 'image'
                  ? `url(${path})`
                  : `url(https://img.youtube.com/vi/${path}/maxresdefault.jpg)`,
            })
          )}
        />
      </div>
    </>
  );
};

const styles = ({ spacing }) => ({
  mediaTitle: {
    textAlign: 'start',
  },
  mediaParagraph: {
    textAlign: 'start',
    marginTop: 0,
    wordBreak: 'break-word',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    '-webkit-box-orient': 'vertical',
    display: '-webkit-box',
    '-webkit-line-clamp': '2',
    '& > p': {
      margin: 0,
    },
  },
  pinned: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    padding: spacing(1, 2.5),
    color: '#008000',
    fontFamily: 'Montserrat',
    backgroundColor: '#DBFAD8',
    borderRadius: '10.0px',
    marginBottom: spacing(1.5),
    marginTop: spacing(1.5),
    '& svg': {
      marginRight: spacing(0.5),
    },
  },
  block: {
    minHeight: '22vh',
    borderRadius: 10,
    padding: spacing(2),
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    '@media (max-width:768px)': { minHeight: '10vh' },
  },
});

MediaCard.propTypes = {
  data: PropTypes.array,
  refetch: PropTypes.func,
};

export default MediaCard;
